<template>
  <div class="result-modal" @click.self="$emit('close')">
    <div class="result-content fade-in">
      <button class="close-btn" @click="$emit('close')">×</button>
      <div class="result-title">您的缘分城市</div>
      <div class="city-name">{{ city }}</div>
      <div class="city-image" :style="{ backgroundImage: `url(${backgroundImage})` }">
        <!-- <div class="city-image-overlay">{{ city }}</div> -->
      </div>
      <div class="city-slogan" v-if="cityInfo">{{ cityInfo.slogan }}</div>
      <div class="city-description" v-if="cityInfo">
        {{ cityInfo.introduce }}
      </div>
      <div class="rating">
        <div class="stars">{{ starsDisplay }}</div>
        <div class="rating-text">缘分指数</div>
      </div>
      <div class="action-buttons">
        <button class="share-btn" @click="shareResult">分享结果</button>
        <button class="guide-btn" @click="$emit('view-guide')">查看攻略</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultModal',
  props: {
    city: {
      type: String,
      required: true
    },
    cityInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      backgroundImage: '',
      starRating: 5 // 默认5颗星，将在mounted中随机生成
    }
  },
  computed: {
    starsDisplay() {
      // 根据starRating生成对应数量的星星
      const filledStars = '★'.repeat(this.starRating)
      const emptyStars = '☆'.repeat(5 - this.starRating)
      return filledStars + emptyStars
    }
  },
  mounted() {
    this.setRandomBackground()
    this.generateRandomRating()
  },
  methods: {
    shareResult() {
      alert('分享功能开发中...')
    },
    setRandomBackground() {
      // 随机选择bg.png或bg1.png到bg10.png中的一张图片
      const imageNames = ['bg.png', 'bg1.png', 'bg2.png', 'bg3.png', 'bg4.png', 'bg5.png', 'bg6.png', 'bg7.png', 'bg8.png', 'bg9.png', 'bg10.png']
      const randomIndex = Math.floor(Math.random() * imageNames.length)
      const selectedImage = imageNames[randomIndex]
      
      try {
        this.backgroundImage = require(`@/assets/${selectedImage}`)
      } catch (error) {
        console.warn(`无法加载图片: ${selectedImage}，使用默认背景`)
        this.backgroundImage = ''
      }
    },
    generateRandomRating() {
      // 随机生成1到5之间的整数
      this.starRating = Math.floor(Math.random() * 5) + 1
    }
  }
}
</script>

<style scoped>
.result-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding-left: 20px; /* 保持左边距 */
  padding-top: 60px; /* 添加顶部边距，使其偏上显示 */
}

.result-content {
  background: white;
  border-radius: 20px;
  padding: 40px;
  max-width: min(500px, 95vw);
  width: 100%;
  max-height: calc(90vh - 60px); /* 调整最大高度，考虑顶部边距 */
  overflow-y: auto;
  text-align: center; /* 保持内容居中 */
  position: relative;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  margin: 0; /* 移除自动居中 */
  box-sizing: border-box;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .result-modal {
    padding-left: 10px; /* 移动端减少左边距 */
    padding-right: 10px; /* 添加右边距防止溢出 */
    padding-top: 40px; /* 移动端减少顶部边距 */
  }
  
  .result-content {
    max-width: calc(100vw - 20px); /* 确保不超出屏幕 */
    max-height: calc(90vh - 40px); /* 调整移动端最大高度 */
  }
}

@media (max-width: 480px) {
  .result-modal {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 30px; /* 小屏幕进一步减少顶部边距 */
  }
  
  .result-content {
    max-width: calc(100vw - 10px);
    padding: 20px;
    max-height: calc(90vh - 30px);
  }
}
.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  z-index: 10;
}

.result-title {
  color: #667eea;
  font-size: 18px;
  margin-bottom: 20px;
}

.city-name {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  word-break: break-all;
}

.city-image {
  width: 100%;
  height: 250px;
  background: linear-gradient(45deg, rgba(0, 255, 255, 0.1), rgba(255, 0, 255, 0.1));
  border: 1px solid #00ffff;
  border-radius: 15px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00ffff;
  font-size: 16px;
  font-family: 'Courier New', monospace;
  text-shadow: 0 0 10px #00ffff;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.city-image-overlay {
  background: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 
    0 0 10px #00ffff,
    0 0 20px #00ffff;
  border: 1px solid rgba(0, 255, 255, 0.5);
  backdrop-filter: blur(5px);
}

.city-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 255, 255, 0.2), transparent);
  animation: scan 3s linear infinite;
  z-index: 1;
}

.city-image-overlay {
  position: relative;
  z-index: 2;
}

@keyframes scan {
  0% { left: -100%; }
  100% { left: 100%; }
}

.city-slogan {
  font-size: 20px;
  color: #667eea;
  font-weight: 500;
  margin-bottom: 15px;
  line-height: 1.4;
}

.city-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  text-align: left;
  padding: 0 10px;
}

.rating {
  margin-bottom: 30px;
}

.stars {
  color: #ffd700;
  font-size: 24px;
  margin-bottom: 10px;
}

.rating-text {
  color: #999;
  font-size: 14px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.share-btn, .guide-btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 44px;
}

.share-btn {
  background: #2ecc71;
  color: white;
}

.guide-btn {
  background: #e74c3c;
  color: white;
}

.share-btn:hover, .guide-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.5s ease-in;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .result-modal {
    padding: 10px;
  }
  
  .result-content {
    max-width: 95vw;
    padding: 25px 20px;
    border-radius: 15px;
  }
  
  .city-name {
    font-size: 24px;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 12px;
  }
  
  .action-buttons button {
    width: 100%;
    min-height: 44px;
  }
}

/* 小屏幕设备优化 */
@media (max-width: 480px) {
  .result-modal {
    padding: 5px;
    padding-top: 3vh;
  }
  
  .result-content {
    padding: 20px 15px;
    max-height: 90vh;
    border-radius: 12px;
    max-width: 98vw;
  }
  
  .city-name {
    font-size: 22px;
  }
  
  .city-image {
    height: 120px;
    font-size: 13px;
  }
  
  .city-slogan {
    font-size: 16px;
    margin: 15px 0;
  }
  
  .city-description {
    font-size: 13px;
    line-height: 1.5;
    margin: 15px 0;
  }
}

/* 超小屏幕优化 */
@media (max-width: 360px) {
  .result-content {
    padding: 15px 10px;
    max-width: 99vw;
  }
  
  .city-name {
    font-size: 20px;
  }
  
  .city-image {
    height: 100px;
  }
  
  .city-slogan {
    font-size: 15px;
  }
  
  .city-description {
    font-size: 12px;
  }
}

/* 横屏模式优化 */
@media (max-width: 768px) and (orientation: landscape) {
  .result-modal {
    align-items: center;
    padding-top: 2vh;
  }
  
  .result-content {
    max-height: 95vh;
    padding: 20px;
    max-width: 90vw;
  }
  
  .city-image {
    height: 100px;
  }
  
  .action-buttons {
    flex-direction: row;
    gap: 10px;
  }
}
</style>